



















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SaveButton extends Vue {
  @Prop()
  valid!: boolean;

  @Prop()
  saveFunction!: (e?: Event) => Promise<any>;

  @Prop()
  buttonText?: string;

  @Prop()
  successText?: string;

  @Prop()
  text?: boolean;

  @Prop()
  icon?: string;

  @Prop()
  depressed?: boolean;

  @Prop()
  px?: number;

  @Prop()
  isIcon?: boolean;

  @Prop()
  color?: string;

  @Prop({ default: () => '' })
  errorText?: string;

  saving = false;

  saving_successful = false;

  saving_error = false;

  tooltip = false;

  async save(e: Event) {
    if (this.saving) return;
    this.saving = true;
    this.saveFunction(e)
      .then(() => {
        setTimeout(() => {
          this.saving = false;
          this.saving_successful = true;
        }, 500);
        setTimeout(() => {
          this.saving_successful = false;
        }, 3000);
      })
      .catch((err) => {
        console.error(err);
        setTimeout(() => {
          this.saving = false;
          this.saving_error = true;
        }, 500);
        setTimeout(() => {
          this.saving_error = false;
        }, 3500);
      });
  }
}
